"use strict";
import React, {Component} from "react";
import {PropTypes} from "Subschema";
import Terms from "../types/credit/Terms.jsx";
export default class CreditTerms extends Component {

    static propTypes = {
        styleClass: PropTypes.style
    };

    static injectedProps = {
        styleClass: "CreditContainer"
    };

    render() {
        const {wallOfTextClass, printClass, headerClass} = this.props;

        return <div>
            <div className={wallOfTextClass}>
                <Terms/>
            </div>
        </div>
    }
}


/** WEBPACK FOOTER **
 ** ./src/templates/CreditTerms.jsx
 **/